import { useEffect, useState } from 'react';
import { IconCloseCircle, Select, SelectType, ToggleInput } from '@ui/src';
import {
  TransactionTypeAllowedTransfersEnum,
  TransactionType as TransactionTypeProps,
} from '../../../hoc/settings/types';
import { TransactionTypeItemProps } from './types';

import cn from './styles.module.css';

const TransactionType = ({
  transactionType,
  transactionTypes,
  setTransactionTypes,
}: TransactionTypeItemProps) => {
  const [formValues, setFormValues] = useState<TransactionTypeProps>();

  const onChange = (e: any) => {
    const nextFormValues = { ...formValues };

    const nextTransactionTypes = transactionTypes?.map((item) => {
      const result = { ...item };

      if (e.target.name === `active-${item.id}`) {
        nextFormValues.active = e.target.checked as boolean;
        result.active = e.target.checked;
      } else if (e.target.name === `allowedTransfers-${item.id}`) {
        nextFormValues.allowedTransfers = e.target.value;
        result.allowedTransfers = e.target.value;
      }

      return result;
    });

    setFormValues(nextFormValues as TransactionTypeProps);
    setTransactionTypes(nextTransactionTypes as TransactionTypeProps[]);
  };

  useEffect(() => {
    setFormValues(transactionType);
  }, [transactionType]);

  return (
    <div className={cn.transactionTypeWrapper}>
      <div className={cn.transactionTypeName}>
        {transactionType?.name
          ?.split('_')
          ?.map((item) => `${item.charAt(0)}${item.slice(1).toLowerCase()}`)
          ?.join(' ')}
      </div>
      <div className={cn.transactionTypeControlsWrapper}>
        <div className={cn.formGroup}>
          <ToggleInput
            name={`active-${transactionType?.id}`}
            title="Available"
            checked={formValues?.active}
            onChange={onChange}
          />
        </div>
        <Select
          name={`allowedTransfers-${transactionType?.id}`}
          title="Customer Available transfers"
          value={formValues?.allowedTransfers}
          placeholder="Choose value"
          list={[
            {
              name: 'Any customers',
              value: TransactionTypeAllowedTransfersEnum.ANY_TRANSFERS,
            },
            {
              name: 'Own accounts',
              value: TransactionTypeAllowedTransfersEnum.OWN_ACCOUNTS,
            },
          ]}
          onChange={onChange}
          mode={SelectType.MULTIPLE}
        />
        {!formValues?.allowedTransfers?.length && (
          <div className={cn.transferUnavailable}>
            <IconCloseCircle />
            This Transaction type is disabled for customers
          </div>
        )}
      </div>
    </div>
  );
};

export default TransactionType;
